import DocumentsCategoriesDlg from "@/views/documents/documents-categories-dlg/DocumentsCategoriesDlg.vue";
import DocumentsAddDlg from "@/views/documents/documents-add-dlg/DocumentsAddDlg.vue";
import { Document } from "@/models/documents/Document";
import moment from "moment";

export default {
  name: "DocumentsList",
  components: {
    DocumentsCategoriesDlg,
    DocumentsAddDlg
  },
  data() {
    return {
      loading: false,
      search: "",
      filters: {
        category: '',
      },
      addCategoryDialog: false,
      headers: [
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Title'],
          align: "start",
          value: "name",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Description'],
          align: "start",
          value: "description",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['ContentLibraryList.Categories'],
          value: 'categoryNames',
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['ContentLibraryList.CreatedBy'],
          value: 'createdByStaffName',
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['ContentLibraryList.LastModified'],
          align: 'start',
          value: 'dateTimeUpdated',
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Status'],
          align: 'start',
          value: 'isEnabled',
        },
      ]
    }
  },
  computed: {
    filteredDocuments(): Document[] {
      if(this.filters.category.length){
        return this.documents.filter((c) => c.categoryIds.includes(this.filters.category))
      }
      return this.documents;
    },
    documents(): Document[] {
      return this.$store.state.documentsModule.documents.map(x => {
        return {
          ...x,
          dateTimeUpdated: moment(x.dateTimeUpdated.seconds * 1000).format(this.facility.dateFormat)
        }
      });
    },
    categories() {
      return this.$store.state.documentsModule.documentsCategories;
    },
    categoryFilter() {
      return [
        {
          id: '',
          name: 'All',
        },
        ...this.categories,
      ];
    },
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    }
  },
  async mounted() {
    await this.$store.dispatch("getDocuments");
    await this.$store.dispatch("getDocumentsCategories");
    this.$store.dispatch("getFacilities")
    this.loading = false;
  },
  methods: {
    openCategories() {
      this.$refs.documentsCategoriesDlg.open();
    },
    openAddDocument() {
      this.$refs.documentsAddDlg.open();
    },
    handleClickDocument(row) {
      this.$router.push({
        name: `DocumentView`,
        params: {
          id: row.id,
        },
      })
    }
  }
}